import * as React from 'react';
import { Config } from '../helpers';
import GroupDropdown from './GroupDropdown';
import { FilterButton } from '../../faceted-search/react/helper';
import Offcanvas from '../../faceted-search/react/Offcanvas';
import OffcanvasContent from './OffcanvasContent';
import ChartErrorBoundary from './ChartErrorBoundary';

// Shared layout shell for both TypesenseProvider and OpenSearchProvider.
// Each provider supplies its own search-context wrapper around this component
// and passes the provider-specific render slots.
//
// Naming note: `groupLabel` (string) is the currently-selected group's label
// for the dropdown. `renderGroupLabel` is a render slot for the breadcrumb
// strip that shows active filter values. They are unrelated.
export default function ChartLayout({
  css,
  title,
  currentGroup,
  groups,
  groupLabel,
  handleGroupChange,
  renderFilter,
  renderGroupLabel,
  renderHits,
  clearAllOuter = null,
  clearAllSidebar = null,
}) {
  const hasFilters = currentGroup.filters?.length > 0;
  const filterNodes = hasFilters ? currentGroup.filters.map(renderFilter) : null;

  return (
    <div className={css.root}>
      {clearAllOuter}
      <Offcanvas title='Filters' callback={() => {}}>
        <OffcanvasContent>
          <div className='nv-chart__filters'>
            <GroupDropdown groupLabel={groupLabel} groups={groups} valueSetter={handleGroupChange}/>
            {filterNodes}
          </div>
        </OffcanvasContent>
      </Offcanvas>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-3 d-none d-lg-block d-xl-block d-xxl-block'>
            <div className='nv-chart__filters desktop-filters'>
              {clearAllSidebar}
              <GroupDropdown groupLabel={groupLabel} groups={groups} valueSetter={handleGroupChange}/>
              <h3 className='h--smaller my-0 nv-chart__filters-heading'>{Config.I18n.Filters.Title}</h3>
              {filterNodes}
            </div>
          </div>
          <div className='col-lg-9'>
            <div className='nv-chart__header'>
              <h3 className='h--small my-0'>{title}</h3>
              <FilterButton/>
            </div>
            <div className='nv-chart__view'>
              <div className='text-center mb-3'>
                <div className='nv-chart__group-description'>
                  <h3 className='h--smallest'>{currentGroup.description}</h3>
                </div>
                <div className='nv-chart__group-label'>
                  {renderGroupLabel?.()}
                </div>
              </div>
              <ChartErrorBoundary>
                {renderHits()}
              </ChartErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
